import React from 'react';
import { CheckCircle2Icon, ChevronRightIcon, LockKeyholeIcon, ZapIcon, ShieldCheckIcon, CreditCardIcon } from 'lucide-react';
import { FadeIn } from './FadeIn';
const plans = [{
  emoji: '📘',
  name: 'MÉTODO PÁDEL',
  tagline: 'El sistema completo para ordenar tus clases.',
  items: ['6 Tomos del Método', '5 Bonos de regalo', 'Acceso inmediato', 'Garantía 7 días'],
  oldPrice: '$89.000',
  price: '$23.990',
  href: 'https://stock.stockdigital.shop/checkout',
  cta: 'QUIERO EL MÉTODO PÁDEL',
  featured: false
}, {
  emoji: '🏆',
  name: 'MÉTODO PÁDEL DEFINITIVO',
  tagline: 'Todo el método + los recursos para la pista.',
  items: ['Método Pádel con sus tomos y bonos', '¡Te llevas más de 50 ejercicios listos para usar!', 'Imágenes explicativas de golpes', 'Acceso inmediato + garantía 7 días'],
  oldPrice: '$129.000',
  price: '$35.990',
  href: 'https://metodopaddle.impultienda.ar/checkout/mega-pack-paddle-definitivo',
  cta: 'QUIERO EL PACK DEFINITIVO',
  featured: true
}];
export function PilatesPricing() {
  return <section id="pricing" className="bg-padel-surface px-4 py-16 sm:py-24" data-id="element-249" data-mp="qxjtjtqbw7nf">
      <div className="mx-auto max-w-5xl" data-id="element-250" data-mp="vsz4act1hnfm">
        <FadeIn data-id="element-251" data-mp="10tdbxtqqavd4">
          <div className="text-center" data-id="element-252" data-mp="10u6cue30aqnc">
            <p className="font-bold tracking-widest text-padel-lime" data-id="element-253" data-mp="10uy79lkvaic1">
              ⏰ PRECIO DE LANZAMIENTO — DISPONIBLE POR TIEMPO LIMITADO
            </p>
            <h2 className="mt-3 font-display text-4xl font-black text-white" data-id="element-254" data-mp="19ttft4bdw4ii">
              ELEGÍ TU PACK
            </h2>
          </div>
        </FadeIn>

        <div className="mt-12 grid items-start gap-6 lg:grid-cols-2" data-id="element-255" data-mp="1en4lv38dgh9d">
          {plans.map((plan, i) => <FadeIn key={plan.name} delay={i * 0.1} data-id="element-256" data-mp="1jlz2byiv9tqb" data-mpi={i}>
              <article className={`relative flex h-full flex-col rounded-3xl border-2 bg-padel-dark p-8 ${plan.featured ? 'border-padel-lime shadow-[0_0_35px_rgba(197,255,61,.16)]' : 'border-padel-muted'}`} data-id="element-257" data-mp="1okir06ouhjmd">
                {plan.featured && <span className="absolute -top-3 left-8 rounded-full bg-padel-lime px-3 py-1 text-xs font-black uppercase tracking-wider text-padel-dark" data-id="element-258" data-mp="28cxete3ygky">
                    RECOMENDADO: 85% de los profes eligen el Pack Definitivo
                  </span>}

                <p className="text-3xl" data-id="element-259" data-mp="c8nbeg7yvs16">{plan.emoji}</p>
                <h3 className="mt-4 font-display text-2xl font-black text-white sm:text-3xl" data-id="element-260" data-mp="76eej8rz45ts">
                  {plan.name}
                </h3>
                <p className="mt-2 text-sm text-gray-400" data-id="element-261" data-mp="l54lrh8iblvv">{plan.tagline}</p>

                <div className="my-7 space-y-3" data-id="element-262" data-mp="h658n9cmgitc">
                  {plan.items.map(item => <p key={item} className="flex gap-2 text-gray-200" data-id="element-263" data-mp="2mz3xu4tge79m">
                      <CheckCircle2Icon className="h-5 w-5 shrink-0 text-padel-lime" data-id="element-264" data-mp="2ixs69tr0rbys" />
                      {item}
                    </p>)}
                </div>

                <div className="mt-auto" data-id="element-265" data-mp="2cuf5hknrjmv5">
                  <p className="text-lg text-gray-500 line-through" data-id="element-266" data-mp="2cu5dxsn2l7nc">
                    {plan.oldPrice}
                  </p>
                  <p className={`font-display text-5xl font-black ${plan.featured ? 'text-padel-lime' : 'text-white'}`} data-id="element-267" data-mp="1z15x9nbjx7e7">
                    {plan.price}{' '}
                    <span className="font-sans text-xl font-normal text-gray-400" data-id="element-268" data-mp="1u4fkp9yygtxj">
                      ARS
                    </span>
                  </p>

                  <a href={plan.href} target="_blank" rel="noopener noreferrer" className={`mt-6 flex w-full items-center justify-center gap-2 rounded-xl px-5 py-5 font-display text-lg font-black transition-transform hover:scale-[1.02] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-padel-lime focus-visible:ring-offset-2 focus-visible:ring-offset-padel-dark sm:text-xl ${plan.featured ? 'bg-padel-lime text-padel-dark' : 'border border-padel-lime bg-transparent text-padel-lime hover:bg-padel-lime hover:text-padel-dark'}`} data-id="element-269" data-mp="1g6qz1zx2dirf">
                    {plan.cta} <ChevronRightIcon className="h-6 w-6" data-id="element-270" data-mp="whg9n6kxdx87" />
                  </a>
                </div>
              </article>
            </FadeIn>)}
        </div>

        <div className="mt-8 flex flex-wrap justify-center gap-x-6 gap-y-3 text-sm font-semibold text-gray-400" data-id="element-271" data-mp="mqbua5rc8acu">
          <span className="inline-flex gap-2" data-id="element-272" data-mp="hs0j9rpb3tt1">
            <LockKeyholeIcon className="h-4 w-4 text-padel-lime" data-id="element-273" data-mp="htbm9paxgxj3" />
            Pago 100% seguro
          </span>
          <span className="inline-flex gap-2" data-id="element-274" data-mp="drq53rrd1x33">
            <ZapIcon className="h-4 w-4 text-padel-lime" data-id="element-275" data-mp="8rvdtn3ob5hi" />
            Acceso en 5 minutos
          </span>
          <span className="inline-flex gap-2" data-id="element-276" data-mp="2kd4d3p0iig7c">
            <ShieldCheckIcon className="h-4 w-4 text-padel-lime" data-id="element-277" data-mp="2kgiasjy8e18g" />
            Garantía 7 días
          </span>
          <span className="inline-flex gap-2" data-id="element-278" data-mp="2teuadbh2s9d1">
            <CreditCardIcon className="h-4 w-4 text-padel-lime" data-id="element-279" data-mp="2tg5dd92p5d33" />
            Mercado Pago — Tarjeta — Transferencia
          </span>
        </div>
      </div>
    </section>;
}